import * as React from 'react';
import {Router, Route, Switch, Redirect} from 'react-router-dom';
import * as ReactGA from 'react-ga';

import {AppRoute} from '>shared/lib/navigation';
import {NarrowFooter as Footer} from '>shared/components/landmarks/footer/narrowFooter';

import {Header} from '>components/header';
import {rollbarLogger} from '>lib/logger';
import {RouterErrorBoundary} from '>components/routerErrorBoundary';

import {history} from './history';
import {PrivacyErrorPage} from './pages/error';
import {PRIVACY_POLICY_URL} from '>root/env';

function App({routes}: {routes: AppRoute[]}) {
  if (process.env.ANALYTICS_ENABLED && process.env.ANALYTICS_ACCOUNT_ID) {
    const trackingId = process.env.ANALYTICS_ACCOUNT_ID;
    ReactGA.initialize(trackingId);

    history.listen((location: any) => {
      ReactGA.set({page: location.pathname});
      ReactGA.pageview(location.pathname);
    });
  }

  return (
    <div className="App">
      <React.Suspense fallback="">
          <Router history={history}>
            <Header />
            <RouterErrorBoundary rollbarLogger={rollbarLogger}>
              <Switch>
                <Route path="/error" render={(props) => <PrivacyErrorPage {...props} />} />
                <Route
                  path="/"
                  render={() => (
                    <Switch>
                      {routes.map((route) => (
                        <Route
                          key={route.path}
                          exact
                          path={`${route.path}`}
                          render={(props) => <route.Component {...props} />}
                        ></Route>
                      ))}
                      <Route path="/">
                        <Redirect to="/" />
                      </Route>
                    </Switch>
                  )}
                />
              </Switch>
            </RouterErrorBoundary>
            <Footer privacyPolicyUrl={PRIVACY_POLICY_URL} />
          </Router>
      </React.Suspense>
    </div>
  );
}

export default App;
